module.exports = function() {
  return new Worker(__webpack_public_path__ + "ebe972525ac183354e89.worker.js");
};